<template>
  <div class="BestSellerList">
      <p class="name">畅销榜单</p>
       <div class="bestseller-list" data-mcs-theme="dark">
           <div class="bestseller-item" v-for="(item, index) in sellwelllist" :key="index" @click="routedetails(item.innerid)">
               <p>{{item.subject}}</p>
           </div>
        </div> 
        <div class="bestseller-logo">
            <img src="~common/images/report/index/icon-cxbd.png" alt="畅销榜单">
        </div>
  </div>
</template>

<script>
import $ from 'jquery'
import 'malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.concat.min.js'
import 'malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.css'
export default {
  name: 'BestSellerList',
  props: ['sellwelllist'],
  data () {
    return {}
  },
  mounted () {
  },
  updated() {
      this.$nextTick(() => {
          $('.bestseller-list').mCustomScrollbar()
      })
  },
  methods: {
    routedetails(innerid) {
      this.$parent.routerDetails(innerid)
    },
  },
  filters: {},
  watch: {},
  computed: {},
  components: {}
}
</script>

<style lang="scss" type="text/scss" scoped>
.BestSellerList {
    float: right;
    position: relative;
    margin-top: 30px;
    padding: 20px;
    padding-right: 0;
    padding-bottom: 60px;
    width:290px;
    height:805px;
    box-sizing: border-box;
    background: linear-gradient(156deg,rgba(248,249,249,1) 0%,rgba(219,219,220,1) 100%);
    background: -webkit-linear-gradient(156deg,rgba(248,249,249,1) 0%,rgba(219,219,220,1) 100%);
    background: -ms-linear-gradient(156deg,rgba(248,249,249,1) 0%,rgba(219,219,220,1) 100%);
    background: -o-linear-gradient(156deg,rgba(248,249,249,1) 0%,rgba(219,219,220,1) 100%);
    border-radius:6px;
   

    .bestseller-logo {
        margin-left: auto;
        width: 136px;
        height: 42px;
        img {
            width: 100%;
            height: 100%;
        }
    }
    .name {
        padding-bottom: 10px;
        font-size:16px;
        font-weight: bold;
    }
    .bestseller-list {
        overflow-x: auto;
        height: 723px;
        .bestseller-item {
            position: relative;
            margin-right: 20px;
            padding: 20px 0;
            border-bottom: solid 1px #E5E5E5;
            p {
                position: relative;
                padding-left: 18px;
                margin: auto;
                max-height: 100px;
                width: 216px;
                font-size: 14px;
                color: #666;
                line-height: 20px;
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
                word-break: break-all;
                cursor: pointer;
                &:hover {
                    color: #409EFF;
                }
            }
            &::after {
                content: '';
                display: block;
                position: absolute;
                top: 25px;
                left: 0px;
                width: 8px;
                height: 8px;
                background: #CCCCCC;
            }
            &:nth-child(1)::after  {
                background: #F56C6C;
            }
            &:nth-child(2)::after  {
                background: #FFA904;
            }
            &:nth-child(3)::after  {
                background: #0ABF53;
            }
        }
    }
}   
</style>